import React from 'react';

import { UIProvider } from '@/contexts/UIContext';

export default ({ element }) => {
  return <UIProvider>{element}</UIProvider>;
};
